import { Coins, Eye, CreditCard } from "lucide-react";
import { Reveal } from "./Reveal";

const cards = [
  {
    icon: Coins,
    title: "Powered by credits",
    body: "ORIVA runs on a simple credits system. Every AI action spends credits — for example, a chat message costs 2 credits — so you only ever use what you need.",
  },
  {
    icon: Eye,
    title: "Costs shown upfront",
    body: "The app always shows your remaining balance and what an action costs before you confirm it. No surprises, no hidden deductions.",
  },
  {
    icon: CreditCard,
    title: "Billed via Google Play",
    body: "Subscriptions are billed securely through Google Play in INR. Your plan determines your credits and limits — exact details are shown in the app before purchase.",
  },
];

export const CreditsSection = () => (
  <section id="credits" className="bg-white pb-24 sm:pb-32" data-testid="credits-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Subscription & credits</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
          One balance. Total clarity.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-4 md:grid-cols-3">
        {cards.map((card, i) => (
          <Reveal key={card.title} delay={i * 0.08}>
            <article
              className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7"
              data-testid={`credits-card-${i}`}
            >
              <div className="grid h-11 w-11 place-items-center rounded-xl bg-emerald-50">
                <card.icon className="h-5 w-5 text-oriva-cyan" />
              </div>
              <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-slate-900">
                {card.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{card.body}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
